

































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { UnitBaseData, UnitPositionData, emptyData, viewUnitInfo } from '@/api/heritageUnit/unitBase'
import UnitPositionsView from '../positions.vue'
import UnitFileGallery from '../fileGallery.vue'
import UnitFileDetail from '../fileDetail.vue'
import Element from 'element-ui'
import ViewDialog from '@/components/dialog/viewDialog.vue'

@Component({
  components: { ViewDialog, UnitPositionsView, UnitFileGallery, UnitFileDetail }
})
export default class UnitPartView extends Vue {
  public name = 'UnitPartView'
  public showDialog: boolean = false
  public expandNames: string[] = ['base']
  public showDraws: boolean = false
  public showPics: boolean = false
  public formTitle: string = '文物组成部分'

  public loading: boolean = false
  public form: UnitBaseData = Object.assign({}, emptyData)
  public $refs!: {
    formData: Element.Form
  }
  public created() {
  }
  public mounted() {
    window.eventBus.$on("viewUnitPart", (id: number) => {
      this.showDialog = true
      this.fetchData(id)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("viewUnitPart")
  }
  public closeDialog() {
    this.showDialog = false
  }
  public fetchData(id: number) {
    this.loading = true
    viewUnitInfo(id).then((response: { data: any }) => {
      var data = response.data
      if (data) {
        this.form = data
        this.formTitle = data.ParentName + '-' + data.HeritageName
        this.setPic()
      }
      this.loading = false
    }).catch((error: any) => {
      console.log(error)
    })
  }
  public setPic() {
    const f = this.form
    this.showDraws = f.Drawings && f.Drawings.length > 0
    // if (this.showDraws) {
    //   this.expandNames.push('draws')
    // }
    this.showPics = f.Pictures && f.Pictures.length > 0
    // if (this.showPics) {
    //   this.expandNames.push('pics')
    // }
  }
  public openMap() {
    const data: { points: UnitPositionData[], unitId: number, mapTitle: string } = {
      points: this.form.PositionList,
      unitId: this.form.Id,
      mapTitle: this.formTitle
    }
    window.eventBus.$emit('openUnitCoordPreview', data)
  }
}
